<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-end pe-5">
                    <h3 class="fw-bold my-4">خدمات ما برای صاحبان کسب‌وکارها</h3>
                    <!-- <h5 class="fw-bold my-4">خدمات متنوع و تخصصی بازار ارزهای دیجیتال</h5>
                    <h6 class="my-4">با استفاده از بروز ترین خدمات حداکثر بازدهی را تجربه کنید</h6> -->
                    <button class="btn-blue mt-5">ثبت نام رایگان</button>
                </div>
                <div class="col-md-5 text-start">
                    <img src="../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">خدمات ما برای صاحبان کسب‌وکارها</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        در دنیای رقابتی امروز، کسب‌وکارها برای حفظ جایگاه خود و افزایش سودآوری نیازمند استفاده از فناوری‌های نوین و رویکردهای نوآورانه هستند. ما در شرکت خود، با تکیه بر دانش تخصصی و فناوری‌های پیشرفته، راهکارهای متنوعی را برای بهینه‌سازی فرآیندهای کسب‌وکار، افزایش بهره‌وری و بهبود تصمیم‌گیری ارائه می‌دهیم. خدمات ما به صاحبان کسب‌وکار کمک می‌کند تا به شکل هوشمندانه‌تری رشد کنند و فرصت‌های جدید را کشف نمایند.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-end">
                        <h4 class="fw-bold">چالش‌های صاحبان کسب‌وکار</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    عدم دسترسی به داده‌های تحلیلی و تصمیم‌گیری آگاهانه
                                </li>
                                <li class="mt-3">
                                    مدیریت ناکارآمد منابع و فرآیندها
                                </li>
                                <li class="mt-3">
                                    رقابت شدید و نیاز به نوآوری مستمر
                                </li>
                                <li class="mt-3">
                                    چالش‌های بازاریابی و جذب مشتریان جدید
                                </li>
                                <li class="mt-3">
                                    افزایش هزینه‌های عملیاتی و کاهش بهره‌وری
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">راهکارهای ما برای صاحبان کسب‌وکار</h3>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">تحلیل و مدیریت داده‌های کسب‌وکار</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>جمع‌آوری، پردازش و تحلیل داده‌های فروش، بازار و مشتریان</li>
                                <li>پیاده‌سازی داشبوردهای تحلیلی برای تصمیم‌گیری بهتر</li>
                                <li>بهینه‌سازی فرآیندهای کسب‌وکار با استفاده از تحلیل داده‌ها</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img9.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">هوش مصنوعی برای بهبود عملکرد کسب‌وکار</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>استفاده از مدل‌های یادگیری ماشین برای پیش‌بینی فروش و رفتار مشتریان</li>
                                <li>بهینه‌سازی استراتژی‌های قیمت‌گذاری و تبلیغات</li>
                                <li>هوشمندسازی فرآیندهای داخلی و کاهش هزینه‌های عملیاتی</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> دیجیتال مارکتینگ و افزایش نرخ تبدیل مشتریان</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تدوین استراتژی‌های بازاریابی دیجیتال متناسب با نوع کسب‌وکار</li>
                                <li>بهینه‌سازی تبلیغات آنلاین و مدیریت شبکه‌های اجتماعی</li>
                                <li>تحلیل رفتار مشتریان و ارائه راهکارهای شخصی‌سازی شده</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img10.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/Secure.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">پیاده‌سازی بلاکچین برای امنیت و شفافیت کسب‌وکار</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>ایجاد قراردادهای هوشمند برای خودکارسازی تراکنش‌ها</li>
                                <li>افزایش امنیت داده‌ها و جلوگیری از جعل و تقلب</li>
                                <li>ایجاد سیستم‌های غیرمتمرکز برای مدیریت اطلاعات و پرداخت‌ها</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/Secure.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> مدیریت و بهینه‌سازی فرآیندهای مالی و سرمایه‌گذاری</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل ساختار مالی و ارائه پیشنهادات برای کاهش هزینه‌ها</li>
                                <li>مشاوره در زمینه سرمایه‌گذاری‌های هوشمند و سودآور</li>
                                <li>مدیریت نقدینگی و بهینه‌سازی جریان‌های مالی</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img11.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> توسعه نرم‌افزارهای اختصاصی کسب‌وکار</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>طراحی و توسعه نرم‌افزارهای مدیریتی سفارشی‌سازی شده</li>
                                <li>یکپارچه‌سازی سیستم‌های مختلف برای بهبود کارایی سازمانی</li>
                                <li>بهینه‌سازی نرم‌افزارهای موجود برای افزایش بهره‌وری</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> مشاوره در تحول دیجیتال و استراتژی‌های نوین کسب‌وکار</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>ارزیابی وضعیت فعلی کسب‌وکار و ارائه نقشه راه دیجیتالی‌سازی</li>
                                <li>بهینه‌سازی مدل‌های کسب‌وکار بر اساس فناوری‌های روز</li>
                                <li>ارائه راهکارهای نوآورانه برای رشد و توسعه پایدار</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img12.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-end">نتایج و ارزش‌آفرینی برای صاحبان کسب‌وکار</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img13.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش کارایی و کاهش هزینه‌های عملیاتی</strong> با استفاده از هوش مصنوعی و تحلیل داده 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش درآمد و سودآوری</strong> از طریق دیجیتال مارکتینگ و بهینه‌سازی تبلیغات 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش امنیت اطلاعات و تراکنش‌ها</strong> با بهره‌گیری از فناوری بلاکچین 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش امنیت اطلاعات و تراکنش‌ها</strong> با بهره‌گیری از فناوری بلاکچین 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Business.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهینه‌سازی فرآیندهای سازمانی و مدیریت منابع</strong> برای افزایش بهره‌وری 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img15.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>دستیابی به تصمیم‌گیری‌های دقیق‌تر و هوشمندانه‌تر</strong> با استفاده از داده‌های تحلیلی 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img16.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>ایجاد یک مدل کسب‌وکار پایدار و مبتنی بر فناوری</strong> برای آینده‌ای مطمئن‌تر 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>سوالات متداول</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-end">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>چگونه می‌توانم از خدمات شما برای کسب‌وکارم استفاده کنم؟</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-end" style="line-height: 35px !important;">
                        شما می‌توانید از طریق تماس با تیم مشاوره ما، نیازهای خود را مطرح کنید. سپس کارشناسان ما با تحلیل دقیق کسب‌وکار شما، راهکارهای متناسب را ارائه خواهند داد.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>آیا این خدمات برای کسب‌وکارهای کوچک هم مناسب است؟</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، خدمات ما به‌گونه‌ای طراحی شده که متناسب با نیازهای کسب‌وکارهای کوچک، متوسط و بزرگ باشد و بر اساس شرایط شما سفارشی‌سازی خواهد شد.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6> چگونه می‌توانم از تحلیل داده‌ها برای بهبود عملکرد کسب‌وکارم استفاده کنم؟</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        ما با جمع‌آوری و تحلیل داده‌های مربوط به فروش، مشتریان و رقبا، به شما کمک می‌کنیم تا استراتژی‌های بهتری برای رشد و توسعه کسب‌وکار خود اتخاذ کنید.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>آیا استفاده از هوش مصنوعی به مهارت فنی نیاز دارد؟</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        خیر، ما تمامی فرآیندهای پیاده‌سازی و اجرا را بر عهده می‌گیریم و در صورت نیاز، آموزش‌های لازم را به تیم شما ارائه خواهیم داد.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>چه مدت زمانی طول می‌کشد تا نتایج این خدمات را در کسب‌وکار خود ببینم؟</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بسته به نوع خدمات و حوزه فعالیت کسب‌وکار شما، نتایج معمولاً در کوتاه‌مدت قابل مشاهده خواهند بود، اما برخی از راهکارهای استراتژیک ممکن است به زمان بیشتری نیاز داشته باشند.
                        <br>
                        ما در کنار شما هستیم تا با استفاده از فناوری‌های نوین، کسب‌وکار شما را به سمت رشد و موفقیت پایدار هدایت کنیم. جهت دریافت مشاوره و اطلاعات بیشتر، با ما در تماس باشید.
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  left: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  left: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>